import * as React from "react";
import Card from "@mui/material/Card";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import FavoriteIcon from "@mui/icons-material/Favorite";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { Box, Link } from "@mui/material";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import Modal from "./modal";
import CallMadeRoundedIcon from "@mui/icons-material/CallMadeRounded";

export default function ProjectCard({ data }) {
  const Button = styled(MuiButton)(({ pill }) => ({
    borderRadius: pill ? 8 : 4,
    backgroundColor: "rgba(25, 118, 210, 0.2)",
  }));

  const [isLiked, setIsLiked] = React.useState(false);
  const [isProjectView, setIsProjectView] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [isHover, setIsHover] = React.useState(false);
  return (
    <>
      <Card
        sx={{
          display: "flex",
          borderRadius: "35px",
          boxShadow: "0px 0px 40px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box
          width={{ xs: "92vw", sm: "400px" }}
          height={"100%"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent={"space-between"}
        >
          <CardMedia
            component="img"
            image={data.projectImages[0]}
            alt="Paella dish"
            sx={{
              p: 2,
              borderRadius: "35px",
              objectFit: "cover",
              height: "280px",
              display: "flex",
            }}
          />
          <Box
            display={"flex"}
            alignItems={"end"}
            justifyContent={"end"}
            flexDirection={"column"}
            width={"100%"}
            height={"100%"}
          >
            <CardContent
              sx={{
                display: "flex",
                flexDirection: "column",
                textAlign: "left",
              }}
            >
              <Typography
                variant="subtitle1"
                fontWeight={{ xs: 600, sm: 500 }}
                fontSize={{ xs: "1.2rem", sm: "1.4rem" }}
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 1,
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  minHeight: "1rem",
                }}
              >
                {data.projectName}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{
                  display: "-webkit-box",
                  WebkitLineClamp: 3,
                  overflow: "hidden",
                  WebkitBoxOrient: "vertical",
                  minHeight: "1rem",
                }}
              >
                {data?.projectDetails?.description}
              </Typography>
            </CardContent>

            <CardActions
              disableSpacing
              sx={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
              }}
            >
              <Box>
                <IconButton
                  aria-label="add to favorites"
                  onClick={() => setIsLiked(!isLiked)}
                >
                  <FavoriteIcon htmlColor={isLiked && "red"} />
                </IconButton>
                <IconButton
                  aria-label="add to favorites"
                  onClick={() => setIsProjectView(!isProjectView)}
                >
                  {!isProjectView ? (
                    <RemoveRedEyeIcon />
                  ) : (
                    <VisibilityOffIcon />
                  )}
                </IconButton>
              </Box>

              {/* <Button
              variant="outlined"
              pill
              onClick={() => {
                setOpen(true);
                setIsProjectView(!isProjectView);
              }}
            >
              View Project
            </Button> */}
              <Box
                component={"div"}
                sx={{
                  borderRadius: "28px",
                  backgroundColor: "#000",
                  overflow: "hidden",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "10px",
                  cursor: "pointer",
                  // width: "12%",
                }}
                display={"flex"}
                px={1}
                py={1}
                onClick={() => {
                  window.location.href = data.detailsLink;
                }}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
              >
                <Link
                  sx={{
                    display: "flex",
                    width: "fit-content",
                    textDecoration: "none",
                    color: "#fff",
                    fontSize: { xs: ".8rem", sm: "1.2rem" },
                    fontWeight: 700,
                    paddingLeft: "4px",
                  }}
                >
                  View Project{" "}
                </Link>
                <Box
                  display={"flex"}
                  width={"40px"}
                  height={"40px"}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Box
                    alignItems={"center"}
                    justifyContent={"center"}
                    sx={{
                      width: isHover ? "40px" : "10px",
                      height: isHover ? "40px" : "10px",
                      borderRadius: "50%",
                      backgroundColor: "#fff",
                      transition: "all .2s ease-in-out",
                      display: "flex",
                    }}
                  >
                    {isHover && <CallMadeRoundedIcon />}
                  </Box>
                </Box>
              </Box>
            </CardActions>
          </Box>
        </Box>
      </Card>

      <Modal
        data={data}
        open={open || isProjectView}
        handleClose={() => {
          setOpen(false);
          setIsProjectView(!isProjectView);
        }}
      />
    </>
  );
}
